const getBrandedImage = (
  image,
  brand = 'ED',
  assetURL = '/images/onefront/bluestone'
) => {
  const imageBrand = brand === 'TR' ? 'TL' : brand;
  return `${assetURL}/${imageBrand === 'GO' ? 'GV' : imageBrand}/${image}`;
};

export default getBrandedImage;
